import {_} from 'lodash';
import {IObjectSearchParams, template as tpl, viewModel as ObjectSearch} from "../../object/search";
import {IFormTemplate, IObjectData, ITableColumn, TSyncfield} from "../../../index";
import {decodeAndStripHtml, getRawSyncFieldValue, getSearchMarkup, getSyncFieldValue} from "../../../util/misc";
import {IParams as IEllipsisDropdownParams} from "../../button/ellipsis-dropdown"
import {global} from "../../../appContext";
import PromiseRequest from "../../../req/PromiseRequest";
import {getSearchParamsFn} from "../../../util/request";
import {MAX_RESULTS_PER_PAGE} from "../../../constants";
import {nsFormTemplate} from "../template/nsFormTemplate";
import {storeObservable, TStoreId} from "../../../util/sessionstore";
import openFormDialog_v2 = nsFormTemplate.openFormDialog_v2;
import openFormDialog = nsFormTemplate.openFormDialog;
import search_rowHtml from './search-row.html?raw';

export let template: string = tpl.replace(new RegExp(/<!-- \{\{TEMPLATE_ROW}} -->/, 'g'), search_rowHtml);

export class viewModel extends ObjectSearch {

    private readonly req_searchformtemplates: PromiseRequest = new PromiseRequest('searchformtemplate')
    private allFormTemplates!: IFormTemplate[];

    constructor(params: IObjectSearchParams) {
        super(_.defaults(params, {
            type: "form",
        }));
    }

    protected override initMain(): Promise<any> {
        let params = getSearchParamsFn('searchformtemplate')({
            resultsprpage: MAX_RESULTS_PER_PAGE,
        })
        return Promise.resolve()
            .then(() =>
                this.req_searchformtemplates
                    .request(params)
                    .then((data: IFormTemplate[]) => {
                        this.allFormTemplates = data
                    })
            )
    }

    protected override getTableKeys(): string[] {
        let keys: string[] = ['selector', 'Id']
        keys = keys.concat(storeObservable(`search.object.syncfields${this.__objectTypeId}` as TStoreId)())
            .filter(key => this.showTableColumn(key));
        keys.push('func')
        return keys
    }

    protected override getSyncFieldValue(key: string | TSyncfield, obj: IObjectData) {
        switch (key) {
            case 'FormName': {
                const val = getSyncFieldValue(key, obj.syncfields)
                let ret = decodeAndStripHtml(val)
                if (val != ret) {
                    const isSearchable = !!this.table().find((item: ITableColumn) => item.key == key && item.sort);
                    if (isSearchable && this.getRealSearchKey()) {
                        if (_.isString(ret)) {
                            ret = getSearchMarkup(ret, this.searchkey())
                        }
                    }
                    return ret
                }
            }
        }
        return super.getSyncFieldValue(key, obj)
    }

    private getInstanceEllipsisParams(obj: IObjectData): IEllipsisDropdownParams {
        const ret: IEllipsisDropdownParams = {
            buttons: [
                {
                    label: `open subject|s:((form|ac))`,
                    onClick: () => {
                        const formTemplateId = getRawSyncFieldValue('FormId', obj.syncfields)
                        const formTemplate = this.allFormTemplates.find(o => String(o.id) == formTemplateId)
                        if (!formTemplate) {
                            return;
                        }
                        formTemplate.v2form ? openFormDialog_v2(formTemplate, obj) : openFormDialog(formTemplate, obj)
                    },
                    validator: () => global.permissionValidator.isMinCompanyAdmin(),
                },
            ]
        }

        return ret
    }

    override dispose() {
        super.dispose()
        this.req_searchformtemplates.abort()
    }
}
